module.exports = __webpack_public_path__ + "static/media/create-password.f959d966.png";